/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterTypeOfProblemV2Kind = (typeof FilterTypeOfProblemV2Kind)[keyof typeof FilterTypeOfProblemV2Kind];

export const FilterTypeOfProblemV2Kind = {
  type_of_problem_v2: 'type_of_problem_v2',
} as const;
